import { render, staticRenderFns } from "./ItemListAdmin.vue?vue&type=template&id=002c87c8&scoped=true&"
import script from "./ItemListAdmin.vue?vue&type=script&lang=js&"
export * from "./ItemListAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002c87c8",
  null
  
)

export default component.exports